import { render, staticRenderFns } from "./KBtn.vue?vue&type=template&id=a772b698&scoped=true"
import script from "./KBtn.vue?vue&type=script&lang=js"
export * from "./KBtn.vue?vue&type=script&lang=js"
import style0 from "./KBtn.vue?vue&type=style&index=0&id=a772b698&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a772b698",
  null
  
)

export default component.exports